import type { PropertyGroupResponse } from '@/shared/api';

export type StructureBlock = 'published' | 'not-empty' | null;

/**
 * Warum eine Struktur-Aktion nicht geht — dieselbe Bedingung, die der Server prüft.
 *
 * `parentBinding` ist genau dann gesetzt, wenn eine `ChannexPropertyBinding`-Zeile existiert, und
 * genau das fragt der Server ab, bevor er Zusammenführen, Teilen und Archivieren ablehnt. Die
 * Fläche darf deshalb den Knopf gar nicht erst anbieten, statt einen 409 zu provozieren.
 */
export function blockFor(
  group: PropertyGroupResponse,
  action: 'merge' | 'split' | 'archive',
): StructureBlock {
  if (group.parentBinding) {
    return 'published';
  }
  return action === 'archive' && group.apartments.length > 0 ? 'not-empty' : null;
}

export const STRUCTURE_BLOCK_REASON: Record<Exclude<StructureBlock, null>, string> = {
  published:
    'Dieses Objekt ist beim Kanalmanager veröffentlicht. Seine Kennung dort hängt am Objekt — solange die Verbindung steht, bleibt die Struktur, wie sie ist.',
  'not-empty':
    'Ein Objekt lässt sich erst archivieren, wenn kein Apartment mehr darin liegt. Verschieben oder archivieren Sie die Apartments zuerst.',
};

/**
 * Mögliche Ziele einer Zusammenführung. Währung und Zeitzone müssen übereinstimmen — sie gehören
 * dem Objekt und der Server lehnt eine Mischung ab; ein veröffentlichtes Ziel ebenso.
 */
export function mergeTargets(
  all: readonly PropertyGroupResponse[],
  source: PropertyGroupResponse,
): PropertyGroupResponse[] {
  return all.filter(
    (candidate) =>
      candidate.id !== source.id &&
      !candidate.parentBinding &&
      candidate.currency === source.currency &&
      candidate.timezone === source.timezone,
  );
}
